exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.downloadCard[data-v-202ab21e]:hover {\n  background-color: #f5f8fa;\n  border-radius: 5px;\n}\n.downloadIcon[data-v-202ab21e] {\n  height: 60px;\n  fill: #8ca0b3;\n  transition: all ease-in-out 200ms;\n}\n.downloadIcon.small[data-v-202ab21e] {\n    height: 35px;\n}\n.downloadIcon[data-v-202ab21e]:hover {\n    transform: scale(1.04);\n}\n.loadingHolder[data-v-202ab21e] {\n  background: rgba(255, 255, 255, 0.5);\n  width: 35px;\n  height: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-202ab21e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/cardDownload.vue
// module id = 2933
// module chunks = 0